// --- Prefiks użyty dla zmiennych i funkcji w tym module: lazyAds_ ---

// --- Konfiguracja ---
const lazyAds_adsenseActiveElement = document.body;
const lazyAds_adsenseIsActive = lazyAds_adsenseActiveElement.getAttribute('data-adsense-active');
const lazyAds_fallbackTimeout = 4000;

// --- Główna logika ---

// 1. Sprawdź, czy AdSense ma być w ogóle aktywne na tej stronie
if (lazyAds_adsenseIsActive === 'true') {

    console.log('[LazyAds] AdSense jest aktywny dla tej strony. Inicjowanie leniwego ładowania...');

    // Odczytaj ID klienta AdSense (zgodnie z Twoim HTML używamy data-adsense-code)
    const lazyAds_adsenseCodeElement = document.body;
    const lazyAds_adsenseClientCode = lazyAds_adsenseCodeElement.getAttribute('data-adsense-code');

    // 2. Sprawdź, czy udało się odczytać kod klienta
    if (!lazyAds_adsenseClientCode) {
        console.error('[LazyAds] BŁĄD: AdSense jest aktywny, ale nie znaleziono ID klienta w atrybucie data-adsense-code w tagu <body>!');
    } else {
        // --- Logika Lazy Load (tylko jeśli AdSense jest aktywny i kod klienta jest dostępny) ---
        let lazyAds_adsenseLoaded = false;
        let lazyAds_fallbackTimerId = null;

        // Funkcja ładująca skrypt AdSense
        function lazyAds_loadAdSenseScript() {
            if (lazyAds_adsenseLoaded) {
                return; // Już załadowany
            }
            lazyAds_adsenseLoaded = true;
            clearTimeout(lazyAds_fallbackTimerId);
            lazyAds_removeAdSenseListeners(); // Wywołujemy prefiksowaną funkcję

            console.log(`[LazyAds] Ładowanie skryptu Google AdSense dla klienta: ${lazyAds_adsenseClientCode}...`);

            const script = document.createElement('script'); // Zmienna lokalna dla funkcji, nie wymaga prefiksu
            script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${lazyAds_adsenseClientCode}`;
            script.async = true;
            script.crossOrigin = 'anonymous';
            script.onerror = () => { console.error(`[LazyAds] Błąd ładowania skryptu AdSense dla klienta: ${lazyAds_adsenseClientCode}`); };
            document.head.appendChild(script);
        }

        // Funkcja wyzwalająca ładowanie
        function lazyAds_triggerAdSenseLoad() {
            // Sprawdzenie flagi jest też w lazyAds_loadAdSenseScript, ale tutaj pozwala szybciej zakończyć
            if (lazyAds_adsenseLoaded) {
                return;
            }
            lazyAds_loadAdSenseScript(); // Wywołujemy prefiksowaną funkcję
        }

        // Funkcja usuwająca nasłuchiwacze
        function lazyAds_removeAdSenseListeners() {
            window.removeEventListener('scroll', lazyAds_triggerAdSenseLoad);
            window.removeEventListener('mousemove', lazyAds_triggerAdSenseLoad);
            window.removeEventListener('touchstart', lazyAds_triggerAdSenseLoad);
        }

        // --- Dodanie nasłuchiwaczy interakcji (wywołują prefiksowaną funkcję) ---
        window.addEventListener('scroll', lazyAds_triggerAdSenseLoad, { passive: true, once: true });
        window.addEventListener('mousemove', lazyAds_triggerAdSenseLoad, { once: true });
        window.addEventListener('touchstart', lazyAds_triggerAdSenseLoad, { passive: true, once: true });

        // --- Fallback Timer (wywołuje prefiksowaną funkcję) ---
        window.addEventListener('load', () => {
            // Sprawdź ponownie flagę, na wypadek gdyby interakcja nastąpiła między dodaniem listenera a zdarzeniem 'load'
            if (!lazyAds_adsenseLoaded) {
                lazyAds_fallbackTimerId = setTimeout(lazyAds_triggerAdSenseLoad, lazyAds_fallbackTimeout);
            }
        });
        // --- Koniec logiki Lazy Load ---
    } // Koniec bloku 'else' sprawdzającego adsenseClientCode

} else {
    // AdSense nie jest aktywny dla tej strony
    console.log('[LazyAds] AdSense jest nieaktywny dla tej strony (data-adsense-active nie jest "true").');
}